import axios from 'axios';
import './index.sass';

export default ($root) => {
  $root.find('.sidebar-action__radio').on('click', function() {
    axios.post('/personal_settings/toggle_ready_for_work', {}, {
      headers: {
        'Accept': 'application/json',
        "X-CSRF-Token": $('meta[name=csrf-token]').attr('content')
      }
    }).then(({ data }) => {
      if (data.is_ready_for_work) {
        $(this).addClass('sidebar-action__radio--active');
      } else {
        $(this).removeClass('sidebar-action__radio--active');
      }
    })
  })
}
